import { Link } from "react-router-dom";
import aimLogo from "../../assets/aim.png";
import { AimOutlined } from "@ant-design/icons";
import close from "../../assets/close.png";

import "./precisionScores.scss";
import {
  useStorageActions,
  useStorageState,
} from "../../context/storageContext";
import { Modal } from "react-bootstrap";
import { useState } from "react";
import ok from "../../assets/ok.png";
import okHover from "../../assets/okHover.png";
import cancel from "../../assets/cancel.png";
import cancelHover from "../../assets/cancelHover.png";
import back from "../../assets/back.png";
import backHover from "../../assets/backHover.png";
import clearScores from "../../assets/clear_scores.png";
import clearScoresHover from "../../assets/clear_scoresHover.png";

const paddingX = window.innerWidth < 750 ? 50 : 60;

const ConfirmModal = (props) => {
  return (
    <Modal
      id="scores"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={props.isConfirmationVisible}
      onHide={() => props.setIsConfirmationVisible(false)}
      style={{ border: "none" }}
    >
      <Modal.Header
        style={{
          borderColor: "transparent",
          textAlign: "right",
        }}
      >
        <Modal.Title
          id="contained-modal-title-hcenter"
          style={{
            margin: "auto",
            color: "white",
            transform: "translateX(10%)",
          }}
        >
          Confirm Delete
        </Modal.Title>
        <img
          src={close}
          alt="close"
          width={22}
          onClick={() => props.setIsConfirmationVisible(false)}
          style={{ transform: "translate(60%,-200%)" }}
        ></img>
      </Modal.Header>
      <Modal.Body>
        <div
          className="d-flex flex-row justify-content-center align-items-center mt-3"
          style={{ color: "#fb4747", fontSize: "20px" }}
        >
          All the data will be deleted
        </div>
        <div
          className="d-flex flex-row justify-content-center align-items-center"
          style={{ color: "white", fontSize: "20px" }}
        >
          Still want to delete?
        </div>
        <div
          className="d-flex flex-row justify-content-center align-items-center"
          style={{ transform: "translateY(20%)" }}
        >
          <img
            src={ok}
            width={250}
            onClick={(e) => {
              e.preventDefault();
              props.deleteData();
              props.setIsConfirmationVisible(false);
            }}
            onMouseOver={(e) => {
              e.currentTarget.src = okHover;
            }}
            onMouseOut={(e) => {
              e.currentTarget.src = ok;
            }}
            alt="playAgain"
            style={{ margin: "20px" }}
          ></img>

          <img
            src={cancel}
            width={250}
            onClick={(e) => {
              e.preventDefault();
              props.setIsConfirmationVisible(false);
            }}
            onMouseOver={(e) => {
              e.currentTarget.src = cancelHover;
            }}
            onMouseOut={(e) => {
              e.currentTarget.src = cancel;
            }}
            alt="reset"
            style={{ margin: "20px" }}
          ></img>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const Scores = (props) => {
  const { getPrecisionScore, deleteData } = useStorageActions();
  const [isConfirmationVisible, setIsConfirmationVisible] = useState(false);

  // Sorting in Decreasing order of Hits
  // eslint-disable-next-line no-extend-native
  Array.prototype.sort_by = function (key_func, reverse = true) {
    return this.sort(
      (a, b) => (key_func(b) - key_func(a)) * (reverse ? 1 : -1)
    );
  };

  // JSON to 2D Array object
  function jsonArrayTo2D(arrayOfObjects) {
    let header = [],
      AoA = [];
    arrayOfObjects.forEach((obj) => {
      Object.keys(obj).forEach(
        (key) => header.includes(key) || header.push(key)
      );
      let thisRow = new Array(header.length);
      header.forEach((col, i) => (thisRow[i] = obj[col] || ""));
      AoA.push(thisRow);
    });
    AoA.unshift(header);
    return AoA;
  }
  var res = getPrecisionScore();
  var finalResult;

  if (res !== null) {
    var sorted = res.sort_by((el) => el.hits);
    finalResult = jsonArrayTo2D(sorted);
  }

  console.log(res);
  const ChallengeScoreItem = (props) => {
    return (
      <div
        style={{
          color: "white",
          fontSize: "x-large",
          paddingLeft: paddingX,
          paddingRight: paddingX,
          textAlign: "left",
          fontFamily: "consolas",
          fontWeight: 800,
        }}
        id="challengeScore"
      >
        {res === null || res.length === 0 ? <div>No Data to show</div> : null}
        {res !== null && res.length >= 1 ? (
          <div>
            <AimOutlined />
            &nbsp;&nbsp;Hits:{" "}
            <span style={{ color: "#4a46fb" }}>{finalResult[1][2]}</span>{" "}
            &nbsp;&nbsp;Precision:{" "}
            <span style={{ color: "#4a46fb" }}>{finalResult[1][1]}</span>{" "}
          </div>
        ) : (
          ""
        )}
        {res !== null && res.length >= 2 ? (
          <div>
            <AimOutlined />
            &nbsp;&nbsp;Hits:{" "}
            <span style={{ color: "#4a46fb" }}>{finalResult[2][2]}</span>{" "}
            &nbsp;&nbsp;Precision:{" "}
            <span style={{ color: "#4a46fb" }}>{finalResult[2][1]}</span>
          </div>
        ) : (
          ""
        )}
        {res !== null && res.length >= 3 ? (
          <div>
            <AimOutlined />
            &nbsp;&nbsp;Hits:{" "}
            <span style={{ color: "#4a46fb" }}>{finalResult[3][2]}</span>{" "}
            &nbsp;&nbsp;Precision:{" "}
            <span style={{ color: "#4a46fb" }}>{finalResult[3][1]}</span>{" "}
          </div>
        ) : (
          ""
        )}
        {res !== null && res.length >= 4 ? (
          <div>
            <AimOutlined />
            &nbsp;&nbsp;Hits:{" "}
            <span style={{ color: "#4a46fb" }}>{finalResult[4][2]}</span>{" "}
            &nbsp;&nbsp;Precision:{" "}
            <span style={{ color: "#4a46fb" }}>{finalResult[4][1]}</span>{" "}
          </div>
        ) : (
          ""
        )}
        {res !== null && res.length >= 5 ? (
          <div>
            <AimOutlined />
            &nbsp;&nbsp;Hits:{" "}
            <span style={{ color: "#4a46fb" }}>{finalResult[5][2]}</span>{" "}
            &nbsp;&nbsp;Precision:{" "}
            <span style={{ color: "#4a46fb" }}>{finalResult[5][1]}</span>{" "}
          </div>
        ) : (
          ""
        )}
        {res !== null && res.length >= 6 ? (
          <div>
            <AimOutlined />
            &nbsp;&nbsp;Hits:{" "}
            <span style={{ color: "#4a46fb" }}>{finalResult[6][2]}</span>{" "}
            &nbsp;&nbsp;Precision:{" "}
            <span style={{ color: "#4a46fb" }}>{finalResult[6][1]}</span>{" "}
          </div>
        ) : (
          ""
        )}
        {res !== null && res.length >= 7 ? (
          <div>
            <AimOutlined />
            &nbsp;&nbsp;Hits:{" "}
            <span style={{ color: "#4a46fb" }}>{finalResult[7][2]}</span>{" "}
            &nbsp;&nbsp;Precision:{" "}
            <span style={{ color: "#4a46fb" }}>{finalResult[7][1]}</span>{" "}
          </div>
        ) : (
          " "
        )}
        {res !== null && res.length >= 8 ? (
          <div>
            <AimOutlined />
            &nbsp;&nbsp;Hits:{" "}
            <span style={{ color: "#4a46fb" }}>{finalResult[8][2]}</span>{" "}
            &nbsp;&nbsp;Precision:{" "}
            <span style={{ color: "#4a46fb" }}>{finalResult[8][1]}</span>
          </div>
        ) : (
          ""
        )}
        {res !== null && res.length >= 9 ? (
          <div>
            <AimOutlined />
            &nbsp;&nbsp;Hits:{" "}
            <span style={{ color: "#4a46fb" }}>{finalResult[9][2]}</span>{" "}
            &nbsp;&nbsp;Precision:{" "}
            <span style={{ color: "#4a46fb" }}>{finalResult[9][1]}</span>
          </div>
        ) : (
          ""
        )}
        {res !== null && res.length >= 10 ? (
          <div>
            <AimOutlined />
            &nbsp;&nbsp;Hits:{" "}
            <span style={{ color: "#4a46fb" }}>{finalResult[10][2]}</span>{" "}
            &nbsp;&nbsp;Precision:{" "}
            <span style={{ color: "#4a46fb" }}>{finalResult[10][1]}</span>{" "}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  return (
    <div className="d-flex flex-column justify-content-between align-items-center scores bg-animate">
      <ConfirmModal
        deleteData={deleteData}
        isConfirmationVisible={isConfirmationVisible}
        setIsConfirmationVisible={setIsConfirmationVisible}
      />

      <div className="d-flex justify-content-between align-items-center w-100 container mt-3">
        <div
          className="d-flex justify-content-start align-items-center w-100 mt-3"
          style={{ fontSize: "x-large", fontWeight: "700" }}
        >
          <Link
            to="/quick-play"
            className="d-flex justify-content-center align-items-center "
          >
            <img src={aimLogo} className="mr-3 logo" alt="logo" />
          </Link>
        </div>
        <div
          className="d-flex justify-content-end align-items-center w-100 mt-3"
          style={{ fontSize: "x-large", fontWeight: "700", color: "white" }}
        >
          <img
            className="mr-3"
            width={190}
            height={55}
            src={clearScores}
            onMouseOver={(e) => {
              e.currentTarget.src = clearScoresHover;
            }}
            onMouseOut={(e) => {
              e.currentTarget.src = clearScores;
            }}
            onClick={(e) => {
              e.preventDefault();
              setIsConfirmationVisible(true);
            }}
            alt="clear-scores"
          ></img>
          <Link to={`/precision`}>
            <img
              width={190}
              height={55}
              src={back}
              onMouseOver={(e) => {
                e.currentTarget.src = backHover;
              }}
              onMouseOut={(e) => {
                e.currentTarget.src = back;
              }}
              alt="back"
            ></img>
          </Link>
        </div>
      </div>

      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{ fontColor: "white", marginTop: "auto", marginBottom: "auto" }}
      >
        <span
          style={{
            color: "white",
            fontSize: "x-large",
            marginBottom: 30,
            fontWeight: 800,
          }}
        >
          Top 10 Results
        </span>
        <ChallengeScoreItem />
      </div>
    </div>
  );
};

export default Scores;
